import { Box, Flex, Tag } from '@chakra-ui/react';
import { Text } from '@main/complykit/components/text';
import {
  Integration_Handler_Names_Enum,
  Integration_Names_Enum,
  Integration_Service_Names_Enum,
} from '@main/graphql/types.generated';
import { PulsatingCircle } from '@main/ui';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { MarkdownText } from './markdown-text';

export const IntegrationDetails = ({
  providerName,
  connectorName,
  serviceName,
  handlerName,
  helpMessage,
  isActive,
}: {
  providerName: Integration_Names_Enum;
  serviceName?: Integration_Service_Names_Enum;
  handlerName?: Integration_Handler_Names_Enum;
  connectorName?: string;
  helpMessage?: ReactNode;
  isActive?: boolean;
}) => {
  const { t } = useTranslation('integrations');

  return (
    <Flex direction="column" gap={1}>
      <Flex align="center" gap={3}>
        {isActive && <PulsatingCircle />}
        <Text weight="bold">{t(`integrations.${providerName}.name`)}</Text>
        {connectorName && <Tag>{connectorName}</Tag>}
      </Flex>
      <Text>{t(`integrations.${providerName}.description`)}</Text>
      {serviceName && handlerName && (
        <>
          <Text size="sm" weight="bold">
            {t(`integrations.${providerName}.services.${serviceName}.name`, { defaultValue: '' })} -{' '}
            {t(
              `integrations.${providerName}.services.${serviceName}.handlers.${handlerName}.name`,
              { defaultValue: '' },
            )}
          </Text>
          <Box fontSize="sm" lineHeight={6}>
            <MarkdownText
              text={t(
                `integrations.${providerName}.services.${serviceName}.handlers.${handlerName}.description`,
                { defaultValue: '' },
              )}
            />
          </Box>
        </>
      )}
      {helpMessage && (
        <Text size="sm" color="muted">
          {helpMessage}
        </Text>
      )}
    </Flex>
  );
};
